import { IDependencyInitializerDetails } from "@microsoft/applicationinsights-dependencies-js";

// https://github.com/Microsoft/ApplicationInsights-JS/blob/main/API-reference.md#adddependencyinitializer

/**
 * Returns true if the input string is a dfs.core.windows.net host or URL.
 * Matches both hostnames (e.g. devixistoragesa.dfs.core.windows.net) and URLs (e.g. https://devixistoragesa.dfs.core.windows.net/...).
 */
export function isDfsCoreWindowsNet(target: string): boolean {
  // Match either a hostname or a URL with optional protocol and path
  // ^(https?://)? matches optional http/https
  // ([^./]+\.)+dfs\.core\.windows\.net matches subdomains
  // (/|$) ensures it ends with the host or is followed by a slash

  // eslint-disable-next-line no-useless-escape
  return /^(https?:\/\/)?([^.\/]+\.)+dfs\.core\.windows\.net(\/|$)/i.test(target);
}

/**
 * Filter out requests to https://[subdomain].dfs.core.windows.net because:
 * - These are very high volume during upload
 * - They contain SAS tokens in the URL and we should not be logging credentials
 * @returns `false` to drop the telemetry item, `true` to keep it.
 */
export function blobStorageFilter({ item }: IDependencyInitializerDetails): boolean | void {
  const { target } = item;

  if (target && isDfsCoreWindowsNet(target)) {
    // Returning false drops the telemetry item
    return false;
  }
}
